import { render } from "./editor.vue?vue&type=template&id=8d77ce38&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=8d77ce38&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d77ce38"]])

export default __exports__